<template>
    <div class="body" v-if="is_loading">
        <!-- 네비게이션 -->
        <Head :time="current_time" :total_question="total_question" :current_question="current_question" @next="next" :total_part="total_part" :current_part="part"></Head>

        <div class="wrap body-con">
            <h2>빈칸에 들어갈 알맞은 단어를 선택하세요.</h2>
            <h3>
                {{modules.part[this.part][current_question].question}}
            </h3>
            <ul>
                <li class="btn-line mb-20" v-for="(value,key) in modules.part[this.part][current_question].statement" :key="key" @click="check_answer(key)" :class="{'on' : key == answer}">{{value}}</li>
            </ul>
        </div>

        <div class="wrap">
            <div class="btn-fixed"><button class="btn-full" @click="next()">NEXT</button></div>
        </div>

        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
import Head from '@/components/inc_head.vue';
export default {
    name: 'Pre_part01',
    components: {
        Footer,
        Head
    },
    data: () => ({
        current_time : {time:0},
        total_question:0,
        current_question:0,
        is_loading:false,
        modules:{},
        part:1,
        total_part:{part:0},
        answer:"",
        type:"",
        is_update:0
    }),
    mounted() {
        // alert("a");
    //    this.type = this.$route.params.type;

        // console.log(btoa('{"total_part":"6","total_question":5,"module_name":"module3","type":"4","modules":{"part":{"1":[{"second":35,"number":"1","question":"Creating an __________ news station in this small radio market will greatly increase the quality and quantity of information received by listeners.","statement":{"1":"addition","2":"addition","3":"additional","4":"adding"},"img_url":"","mp3_url":"","directive":"","help_word":""},{"second":35,"number":"2","question":"I would like to bring to your attention a rather ____________ situation I recently had.","statement":{"1":"embarrass","2":"embarrassing","3":"embarrassed","4":"embarrassment"},"img_url":"","mp3_url":"","directive":"","help_word":""},{"second":35,"number":"3","question":"Sales volume ________ 20% since last year.","statement":{"1":"increases","2":"increasing","3":"will increase","4":"has increased"},"img_url":"","mp3_url":"","directive":"","help_word":""},{"second":35,"number":"4","question":"________ fuel prices have finally stabilized, the general public should become more confident about the health of the economy.","statement":{"1":"On account of","2":"Therefore","3":"As though","4":"Now that"},"img_url":"","mp3_url":"","directive":"","help_word":""},{"second":35,"number":"5","question":"It is important for those ________ attended the meeting between the CEO and the advisory panel not to disclose what happened.","statement":{"1":"who","2":"whom","3":"which","4":"whose"},"img_url":"","mp3_url":"","directive":"","help_word":""}]}},"submit_answer":"0"}'));
       this.getQuestion();
    },
    methods: {
        getQuestion(){
            var moduel_str = atob(this.$route.params.module);
            var module_json = JSON.parse(moduel_str);
            console.log(module_json);

            this.modules = module_json.modules;
            this.total_part = {part:parseInt(module_json.total_part)};
            this.total_question = module_json.total_question;
            this.current_question = parseInt(module_json.submit_answer);
            this.current_time.time = module_json.modules.part[this.part][this.current_question].second * 1000;
            this.is_loading = true;

            // var params = {
            //     type:this.type,
            //     part:this.part
            // }
            // this.axios.get(this.axios.root + "/rest/module_info/getQuestions",{params:params}).then((res)=>{
            //     console.log(res);
            //     if(res.data.err == 0){
            //         // console.log(res);
            //         this.total_part = {part:parseInt(res.data.data.total_part)};
            //         this.total_question = res.data.data.total_question;
            //         this.modules = res.data.data.modules;
            //         this.current_question = parseInt(res.data.data.submit_answer);
            //         this.current_time.time = this.modules.part[this.part][this.current_question].second * 1000;
            //         this.is_loading = true;
            //     }else if(res.data.err == 5000){
            //         alert(res.data.err_msg);
            //         sessionStorage.clear();
            //         location.href="/intro";
            //     }else if(res.data.err == 6001){
            //         alert(res.data.err_msg);
            //         this.$router.push('/part02/'+this.type);
            //     }else{
            //         alert(res.data.err_msg);
            //         return false;
            //     }
            // })
        },
        next(){
            this.answer = "";
            this.current_question++;
            this.current_time = {time:this.modules.part[this.part][this.current_question].second * 1000};
            // var params = {
            //     part :this.part,
            //     number : (this.current_question+1),
            //     type:this.type,
            //     student_idx:sessionStorage.getItem("student_idx"),
            //     answer:this.answer
            // }
            // console.log(params);
            // this.axios.post(this.axios.root + "/rest/access/answerSubmit",params).then((res) => {
            //     if(res.data.err == 0){
            //         this.answer = "";
            //         if((this.current_question + 1) == this.modules.part[this.part].length){
            //             this.$router.push('/part02/'+this.type);
            //         }else{
            //             this.current_question++;
            //             this.current_time = {time:this.modules.part[this.part][this.current_question].second * 1000};
            //         }
            //     }else{
            //         alert(res.data.err_msg);
            //         return false;
            //     }
            // });
        },
        check_answer(answer){
            this.answer = answer
        }

    }
}
</script>